module.exports = __webpack_public_path__ + "aefb08a0797297a07942209586ecc69b.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/satzung.jpg
// module id = 908
// module chunks = 0